module.exports = __webpack_public_path__ + "images/lender-borrowing-base-logo-2024-101.6dd467f26edbd40b99af2500a99f4046.svg";